<!-- 饼状图 -->
<template>
    <div class="chartMap">
        <div class="left2box">
            <!-- 设置级别<el-input style="width: 100px;" v-model="ZOOM_THRESHOLD"></el-input>
            当前级别{{ zoomDq }} -->
            <div class="echartBox">
                <div id="main" class="chart" ref="mapChartRef" ></div>              
                <div style="position: absolute;right: 10px;z-index:10" :style="{top:top,right:right}">
                    <div @click="zoomIn" title="放大" class="iconButton"><el-icon color="#000"><Plus /></el-icon></div>
                    <div @click="zoomOut" title="缩小" class="iconButton"><el-icon color="#000"><Minus /></el-icon></div>
                    <div @click="setMapCenter" title="回到原点" class="iconButton"><el-icon color="#000"><LocationFilled /></el-icon></div>
                    
                </div>
                
            </div>
        </div>
    </div>
</template>

<script setup>
    import {
        getCurrentInstance,
        ref,
        onMounted,
        onUnmounted,
        watch
    } from "vue";
    import { LocationFilled, Plus, Minus} from '@element-plus/icons-vue'
    import * as echarts from "echarts";
    import worldMap from './world.js'
    import chinaMap from './china.js'
    const { proxy } = getCurrentInstance();
    const props = defineProps({
        top: {
            type: String,
            default() {
                return ''
            }
        },
        right: {
            type: String,
            default() {
                return ''
            }
        }
    })
    const right = props.right
    const top = props.top
    const option = ref({});
    const mapChartRef = ref(null);
    const handleResize = () => {
        try {
            if (myChart && typeof myChart.resize === 'function') {
                myChart.resize({
                    animation: { duration: 300 } // 可选的动画效果
                });
            }
        } catch (e) {
            console.error('Resize error:', e);
        }
    };
    onMounted(() => {
        myChart = echarts.init(mapChartRef.value);
        getInfo();
        window.addEventListener("resize", handleResize);
    });
    onUnmounted(() => {
        window.removeEventListener("resize", handleResize);
    });
    const dataList = ref([]);
    const total = ref(0);
    var color = [
        "#00FFFC",
        "#FFC400",
        "#99D155",
        "#1AD979",
        "#3D99E8",
        "#FF8D3A",
    ];
    const nameList = ref([]);

    const rich = {
        title: {
            color: "#fff",
            fontSize: 14,
        },
        titleUnit: {
            color: "#fff",
            fontSize: 12,
            padding: [10, 0, 0, 0],
        },
        titleValue: {
            color: "rgba(0, 255, 252, 1)",
            fontSize: 18,
            fontWeight: 700,
            padding: [10, 5, 5, 5],
        },
    };
    const title = {
        name: "总数量",
        value: 0,
        unit: "个",
    };

    let myChart = null;
    const ZOOM_THRESHOLD = ref(2.6)
    const zoomDq = ref(1)
    let georoamFlag = false;  //false为默认比例及小于4.5,大于4.5则为true 
    watch(ZOOM_THRESHOLD, (val) => {
        if (val) {
            console.log('ZOOM_THRESHOLD', val)
            georoamFlag = true
        }
    })
    let useMap = { ...worldMap};
    const  initialState = ref({})
    const getInfo = (t) => {
        echarts.registerMap('world', useMap)
        var worldDatas = [
            // 国内流向潍坊 (value: 1)
            { name: '潍坊', value: 1 },
            { name: '兴隆', value: 1 },
            { name: '科右中旗', value: 1 },
            { name: '乌拉特前旗', value: 1 },
            { name: '册亨', value: 1 },
            { name: '彭阳', value: 1 },
            { name: '沾化', value: 1 },
            { name: '平乐', value: 1 },
            { name: '攀枝花', value: 1 },
            { name: '小金', value: 1 },
            { name: '化州', value: 1 },
            { name: '邵阳', value: 1 },
            { name: '泸溪', value: 1 },
            { name: '普洱', value: 1 },
            
            // 潍坊流向国际 (value: 2)
            {
                "name": "俄罗斯",
                "value": 2
            },
            {
                "name": "日本",
                "value": 2
            },
            {
                "name": "韩国",
                "value": 2
            },
            {
                "name": "美国",
                "value": 2
            },
            {
                "name": "沙特阿拉伯",
                "value": 2
            },
            {
                "name": "英国",
                "value": 2
            },
            {
                "name": "法国",
                "value": 2
            },
            {
                "name": "墨西哥",
                "value": 2
            },
            {
                "name": "越南",
                "value": 2
            },
            {
                "name": "印度尼西亚",
                "value": 2
            }
        ];

        // 确保这些地区在坐标字典中存在
        var chinaCoordMap = {
            // 原有坐标保持不变...
            '潍坊': [119.168138, 36.713212],
            '兴隆': [117.500558, 40.429147],
            '科右中旗': [121.476692, 45.060846],
            '乌拉特前旗': [108.652114, 40.736675],
            '册亨': [105.812417, 24.987338],
            '彭阳': [106.637554, 35.857982],
            '沾化': [118.130932, 37.698951],
            '平乐': [110.637305, 24.622053],
            '攀枝花': [101.725262, 26.588109],
            '小金': [102.368459, 31.002558],
            '化州': [110.639723, 21.669064],
            '邵阳': [111.474133, 27.245167],
            '泸溪': [110.220418, 28.216351],
            '普洱': [100.98114, 22.788486]
        };

        // 合并坐标数据
        var worldGeoCoordMap = {
            ...chinaCoordMap,
            // 原有国际坐标保持不变...
            '俄罗斯': [105.318756, 61.52401],
            '日本': [139.6917, 35.6895],
            '韩国': [127.766922, 35.907757],
            '美国': [-77.0369, 38.9072],
            '沙特阿拉伯': [46.6753, 24.7136],
            '英国': [-0.1276, 51.5072],
            '法国': [2.3522, 48.8566],
            '墨西哥': [-99.1332, 19.4326],
            '越南': [105.8342, 21.0278],
            '印度尼西亚': [113.921327, -0.789275],
        };

        let cityMap = {
            "xin_jiang": "新疆",
            "Afghanistan": "阿富汗",
            "Singapore": "新加坡",
            "Angola": "安哥拉",
            "Albania": "阿尔巴尼亚",
            "United Arab Emirates": "阿拉伯联合酋长国",
            "Argentina": "阿根廷",
            "Armenia": "亚美尼亚",
            "French Southern and Antarctic Lands": "法属南半球和南极领地",
            "Australia": "澳大利亚",
            "Austria": "奥地利",
            "Azerbaijan": "阿塞拜疆",
            "Burundi": "布隆迪",
            "Belgium": "比利时",
            "Benin": "贝宁",
            "Burkina Faso": "布基纳法索",
            "Bangladesh": "孟加拉",
            "Bulgaria": "保加利亚",
            "Bahamas": "巴哈马",
            "Bosnia and Herz.": "波黑",
            "Belarus": "白俄罗斯",
            "Belize": "伯利兹",
            "Bermuda": "百慕大",
            "Bolivia": "玻利维亚",
            "Brazil": "巴西",
            "Brunei": "文莱",
            "Bhutan": "不丹",
            "Botswana": "博茨瓦纳",
            "Central African Rep.": "中非",
            "Canada": "加拿大",
            "Switzerland": "瑞士",
            "Chile": "智利",
            "China": "中国",
            "Côte d'Ivoire": "科特迪瓦",
            "Cameroon": "喀麦隆",
            "Dem. Rep. Congo": "刚果（金）",
            "Congo": "刚果",
            "Colombia": "哥伦比亚",
            "Costa Rica": "哥斯达黎加",
            "Cuba": "古巴",
            "Northern Cyprus": "北塞浦路斯",
            "Cyprus": "塞浦路斯",
            "Czech Rep.": "捷克",
            "Germany": "德国",
            "Djibouti": "吉布提",
            "Denmark": "丹麦",
            "Algeria": "阿尔及利亚",
            "Ecuador": "厄瓜多尔",
            "Egypt": "埃及",
            "Eritrea": "厄立特里亚",
            "Spain": "西班牙",
            "Estonia": "爱沙尼亚",
            "Ethiopia": "埃塞俄比亚",
            "Finland": "芬兰",
            "Fiji": "斐济",
            "Falkland Is.": "福克兰群岛",
            "France": "法国",
            "Gabon": "加蓬",
            "United Kingdom": "英国",
            "Georgia": "格鲁吉亚",
            "Ghana": "加纳",
            "Gambia": "冈比亚",
            "Guinea": "几内亚",
            "Guinea-Bissau": "几内亚比绍",
            "Eq. Guinea": "赤道几内亚",
            "Greece": "希腊",
            "Greenland": "格陵兰",
            "Guatemala": "危地马拉",
            "Fr. S. Antarctic Lands": "留尼汪",
            "Guyana": "圭亚那",
            "Honduras": "洪都拉斯",
            "Croatia": "克罗地亚",
            "Haiti": "海地",
            "Hungary": "匈牙利",
            "Indonesia": "印度尼西亚",
            "India": "印度",
            "Ireland": "爱尔兰",
            "Iran": "伊朗",
            "Iraq": "伊拉克",
            "Iceland": "冰岛",
            "Israel": "以色列",
            "Italy": "意大利",
            "Jamaica": "牙买加",
            "Jordan": "约旦",
            "Japan": "日本",
            "Kazakhstan": "哈萨克斯坦",
            "Kenya": "肯尼亚",
            "Kyrgyzstan": "吉尔吉斯斯坦",
            "Cambodia": "柬埔寨",
            "Korea": "韩国",
            "Dem. Rep. Korea": "朝鲜",
            "Kosovo": "科索沃",
            "Kuwait": "科威特",
            "Lao PDR": "老挝",
            "Lebanon": "黎巴嫩",
            "Liberia": "利比里亚",
            "Libya": "利比亚",
            "Sri Lanka": "斯里兰卡",
            "Lesotho": "莱索托",
            "Lithuania": "立陶宛",
            "Luxembourg": "卢森堡",
            "Latvia": "拉脱维亚",
            "Morocco": "摩洛哥",
            "Moldova": "摩尔多瓦",
            "Madagascar": "马达加斯加",
            "Mexico": "墨西哥",
            "Macedonia": "北马其顿",
            "Mali": "马里",
            "Myanmar": "缅甸",
            "Montenegro": "黑山",
            "Mongolia": "蒙古",
            "Mozambique": "莫桑比克",
            "Mauritania": "毛里塔尼亚",
            "Malawi": "马拉维",
            "Malaysia": "马来西亚",
            "Namibia": "纳米比亚",
            "New Caledonia": "新喀里多尼亚",
            "Niger": "尼日尔",
            "Nigeria": "尼日利亚",
            "Nicaragua": "尼加拉瓜",
            "Netherlands": "荷兰",
            "Norway": "挪威",
            "Nepal": "尼泊尔",
            "New Zealand": "新西兰",
            "Oman": "阿曼",
            "Pakistan": "巴基斯坦",
            "Panama": "巴拿马",
            "Peru": "秘鲁",
            "Philippines": "菲律宾",
            "Papua New Guinea": "巴布亚新几内亚",
            "Poland": "波兰",
            "Puerto Rico": "波多黎各",
            "Portugal": "葡萄牙",
            "Paraguay": "巴拉圭",
            "Qatar": "卡塔尔",
            "Romania": "罗马尼亚",
            "Russia": "俄罗斯",
            "Rwanda": "卢旺达",
            "W. Sahara": "西撒哈拉",
            "Saudi Arabia": "沙特阿拉伯",
            "Sudan": "苏丹",
            "S. Sudan": "南苏丹",
            "Senegal": "塞内加尔",
            "Solomon Is.": "所罗门群岛",
            "Sierra Leone": "塞拉利昂",
            "El Salvador": "萨尔瓦多",
            "Somaliland": "索马里兰",
            "Somalia": "索马里",
            "Serbia": "塞尔维亚",
            "Suriname": "苏里南",
            "Slovakia": "斯洛伐克",
            "Slovenia": "斯洛文尼亚",
            "Sweden": "瑞典",
            "Swaziland": "斯威士兰",
            "Syria": "叙利亚",
            "Chad": "乍得",
            "Togo": "多哥",
            "Thailand": "泰国",
            "Tajikistan": "塔吉克斯坦",
            "Turkmenistan": "土库曼斯坦",
            "Timor-Leste": "东帝汶",
            "Trinidad and Tobago": "特立尼达和多巴哥",
            "Tunisia": "突尼斯",
            "Turkey": "土耳其",
            "Tanzania": "坦桑尼亚",
            "Uganda": "乌干达",
            "Ukraine": "乌克兰",
            "Uruguay": "乌拉圭",
            "United States": "美国",
            "Uzbekistan": "乌兹别克斯坦",
            "Venezuela": "委内瑞拉",
            "Vietnam": "越南",
            "Vanuatu": "瓦努阿图",
            "West Bank": "西岸",
            "Yemen": "也门",
            "South Africa": "南非",
            "Zambia": "赞比亚",
            "Zimbabwe": "津巴布韦",
            "Aland": "奥兰群岛",
            "American Samoa": "美属萨摩亚",
            "Andorra": "安道尔",
            "Anguilla": "安圭拉",
            "Antigua and Barb.": "安提瓜和巴布达",
            "Aruba": "阿鲁巴",
            "Bahrain": "巴林",
            "Barbados": "巴巴多斯",
            "Bouvet Island": "布维岛",
            "Cape Verde": "佛得角",
            "Christmas Islands": "圣诞岛",
            "Cocos (keeling) Islands": "科科斯（基林）群岛",
            "Comoros": "科摩罗",
            "Cook Islands": "库克群岛",
            "Dominica": "多米尼克",
            "Dominican Rep.": "多明尼加共和国",
            "Faeroe Is.": "法罗群岛",
            "MetropolitanFrance": "法国大都会",
            "French Polynesia": "法属波利尼西亚",
            "Gibraltar": "直布罗陀",
            "Grenada": "格林纳达",
            "Guam": "关岛",
            "Guernsey": "根西岛",
            "Isle of Man": "马恩岛",
            "Jersey": "泽西岛",
            "Kiribati": "基里巴斯",
            "Liechtenstein": "列支敦士登公国",
            "Maldives": "马尔代夫",
            "Malta": "马耳他",
            "Marshall Islands": "马绍尔群岛",
            "Mauritius": "毛里求斯",
            "Micronesia": "密克罗尼西亚",
            "Monaco": "摩纳哥",
            "Montserrat": "蒙特塞拉特",
            "Nauru": "瑙鲁",
            "Niue": "纽埃",
            "Norfolk Island": "诺福克岛",
            "Palau": "帕劳",
            "Palestine": "巴勒斯坦",
            "Pitcairn Islands": "皮特凯恩群岛",
            "Russian Federation": "俄罗斯联邦",
            "Saint Helena": "圣赫勒拿",
            "Saint Lucia": "圣卢西亚",
            "Saint Kitts-Nevis": "圣基茨和尼维斯",
            "St. Vin. and Gren.": "圣文森特和格林纳丁斯",
            "Samoa": "萨摩亚",
            "San Marino": "圣马力诺",
            "Sao Tome and Principe": "圣多美和普林西比",
            "Seychelles": "塞舌尔",
            "Tokelau": "托克劳",
            "Tonga": "汤加",
            "Tuvalu": "图瓦卢",
            "Vatican City": "梵蒂冈",
            "Wallis and Futuna": "瓦利斯群岛和富图纳群岛",
            "Yugoslavia": "南斯拉夫"
        }

        for (let key in worldGeoCoordMap) {
            let coordX = worldGeoCoordMap[key][0]
            if (coordX <= -30) {
                worldGeoCoordMap[key][0] = 360 + coordX
            }
        }

        

        let coordData = worldDatas.map(item => {
            if (!worldGeoCoordMap[item.name]) {
                console.log('该地区不存在: ' + item.name)
                return
            }
            let value = [...worldGeoCoordMap[item.name], item.value]
            return {
                name: item.name,
                value: value
            }
        })

        var convertData = function (data) {
            var res = [];
            for (var i = 0; i < data.length; i++) {
                var dataItem = data[i];
                var fromCoord = worldGeoCoordMap[dataItem.name];
                var toCoord;
                
                // 根据value值确定流向
                if (dataItem.value === 1) {
                    // 国内->潍坊
                    toCoord = worldGeoCoordMap['潍坊'];
                } else if (dataItem.value === 2) {
                    // 潍坊->国际
                    fromCoord = worldGeoCoordMap['潍坊']; // 修正起点
                    toCoord = worldGeoCoordMap[dataItem.name]; // 终点为国际城市
                }
                
                if (fromCoord && toCoord) {
                    res.push([{
                        coord: fromCoord,
                        value: dataItem.value
                    }, {
                        coord: toCoord
                    }]);
                } else {
                    console.warn('坐标缺失:', 
                        !fromCoord ? '起点' + dataItem.name : '终点' + 
                        (dataItem.value === 1 ? '潍坊' : dataItem.name));
                }
            }
            return res;
        };
        
        // 国内外散点处理
        // 国内数据
        const domesticData = worldDatas.filter(item => 
            !['俄罗斯', '日本', '韩国', '美国', '沙特阿拉伯', '英国', '法国', '墨西哥', '越南', '印度尼西亚'].includes(item.name)
        );

        // 国际数据
        const internationalData = worldDatas.filter(item => 
            ['俄罗斯', '日本', '韩国', '美国', '沙特阿拉伯', '英国', '法国', '墨西哥', '越南', '印度尼西亚'].includes(item.name)
        );
        const createCoordData = (data) => {
            return data.map(item => {
                if (!worldGeoCoordMap[item.name]) {
                    console.log('该地区不存在: ' + item.name);
                    return null;
                }
                return {
                    name: item.name,
                    value: [...worldGeoCoordMap[item.name], item.value]
                };
            }).filter(Boolean);
        };

        const domesticCoord = createCoordData(domesticData);
        const internationalCoord = createCoordData(internationalData);

        var series = [];
        [['', worldDatas]].forEach(function (item, i) {
                series.push({
                    type: 'lines',
                    progressive: 200, // 分片渲染
                    large: true, // 大数据模式
                    // 国内流向潍坊的样式
                    lineStyle: {
                        normal: {
                            color: '#37DAFE', // 蓝色
                            width: 1,
                            curveness: 0.2
                        }
                    },
                    effect: {
                        show: true,
                        color: '#37DAFE',
                        symbolSize: 4,
                        period: 4, //箭头指向速度，值越小速度越快
                        trailLength: 0.2, //特效尾迹长度[0,1]值越大，尾迹越长重
                        // symbol: 'arrow', //箭头图标
                        symbol: 'circle',
                        symbolSize: 5, //图标大小
                    },
                    data: convertData(worldDatas.filter(item => item.value === 1))
                },
                {
                    type: 'lines',
                    // polyline: true, // 使用折线模式减少计算
                    progressive: 200, // 分片渲染
                    large: true, // 大数据模式
                    // 潍坊流向国际的样式
                    lineStyle: {
                        normal: {
                            color: '#FFC400', // 黄色
                            width: 1.5,
                            curveness: 0.3
                        }
                    },
                    effect: {
                        show: true,
                        color: '#FFC400',
                        symbolSize: 4,
                        period: 4, //箭头指向速度，值越小速度越快
                        trailLength: 0.2, //特效尾迹长度[0,1]值越大，尾迹越长重
                        // symbol: 'arrow', //箭头图标
                        symbol: 'circle',
                        symbolSize: 5, //图标大小
                    },
                    data: convertData(worldDatas.filter(item => item.value === 2))
                },
                {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    zlevel: 2,
                    rippleEffect: { //涟漪特效
                        period: 4, //动画时间，值越小速度越快
                        brushType: 'stroke', //波纹绘制方式 stroke, fill
                        scale: 3 //波纹圆环最大限制，值越大波纹越大
                    },
                    label: {
                        normal: {
                            show: false,
                            areaColor: '#36DBFF',
                            position: 'right', //显示位置
                            offset: [5, 0], //偏移设置
                            color:'#37DAFE',//文字颜色
                            formatter: function (params) { //圆环显示文字
                                return params.data.name.replace(/中国\//g, '');
                            },
                            fontSize: 14
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    symbol: 'circle',
                    symbolSize: function (val) {
                        return 4 + val[2] * 5; //圆环大小
                    },
                    itemStyle: {
                        normal: {
                            show: true,
                            color: '#36DBFF' // 字体颜色
                        }
                    },
                    data: domesticCoord
                },
                {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    zlevel: 2,
                    rippleEffect: { //涟漪特效
                        period: 4, //动画时间，值越小速度越快
                        brushType: 'stroke', //波纹绘制方式 stroke, fill
                        scale: 3 //波纹圆环最大限制，值越大波纹越大
                    },
                    label: {
                        normal: {
                            show: true,
                            areaColor: '#FFD11A',
                            position: 'right', //显示位置
                            offset: [5, 0], //偏移设置
                            color:'#FFD11A',
                            formatter: function (params) { //圆环显示文字
                                return params.data.name.replace(/中国\//g, '');
                            },
                            fontSize: 14
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    symbol: 'circle',
                    symbolSize: function (val) {
                        return 4 + val[2] * 5; //圆环大小
                    },
                    itemStyle: {
                        normal: {
                            show: true,
                            color: '#FFD11A' // 字体颜色
                        }
                    },
                    data: internationalCoord
                },
            );
        });

        option.value = {
            backgroundColor: 'transparent',
            title: {
                text: '',
                subtext: '',
                left: 'center',
                top: -3,
                itemGap: 0,
                textStyle: {
                    color: '#fff',
                    fontSize: 20
                },
                z: 200
            },
            tooltip: {
                show: false,
                trigger: 'item',
                backgroundColor: 'rgba(166, 200, 76, 0)',
                borderColor: '#516a89',
                showDelay: 0,
                hideDelay: 0,
                enterable: true,
                transitionDuration: 0,
                extraCssText: 'z-index:100',
                formatter: function (params, ticket, callback) {
                    //根据业务自己拓展要显示的内容
                    var res = "";
                    var name = params.name;
                    var value = params.value[params.seriesIndex + 1];
                    res = "<span style='color:#fff;'>" + name + "</span><br/>数据：" + value;
                    return res;
                }
            },
            // visualMap: [{
            //     show: false,
            //     seriesIndex: 0,
            //     dimension: 0, //取第一维度,批次
            //     right: 10,
            //     bottom: 10,
            //     zlevel: 10,
            //     calculable: true,
            //     min: 0,
            //     max: 10,
            //     inRange: { //由低到高
            //         color: ['#11eb11', '#006edd']
            //     },
            //     textStyle: {
            //         color: '#fff',
            //         fontSize: 14
            //     }
            // }],
            geo: {
                map: 'world',
                silent: true, // 关闭事件检测
                progressive: 200, // 分片渲染
                large: true, // 启用大数据模式
                blurSize: 3, // 降低渲染精度
                roam: true,
                zoom: 0.7,
                nameMap: cityMap,
                center:[162.168138, -10.713212],
                label: {
                    normal: {
                        show: false,
                        fontSize: '10',
                        color: '#fff'
                    },
                    emphasis: {
                        show: true,
                        color: '#fff'
                    }
                },
                itemStyle: {
                    normal: {
                        areaColor: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 1,
                            y2: 1,
                            colorStops: [
                                // { offset: 0, color: '#5EA1D9' },
                                // { offset: 0.5, color: '#326FAC' },
                                // { offset: 1, color: '#0F4789' }
                                
                                // { offset: 0, color: '#082161' },
                                // { offset: 0.5, color: '#0a4b9e' },
                                // { offset: 1, color: '#00a8ff' }
                                { offset: 0, color: '#0A2D7C' },   // 深蓝
                                { offset: 0.7, color: '#1A5B9A' }, // 过渡蓝
                                { offset: 1, color: '#3DBAFF' }
                            ],
                            global: false // 缺省为 false
                        },

                        borderColor: "#00a8ff",
                        borderWidth: 0.5,
                        shadowColor: '#0C2949',
                        shadowBlur: 10,//阴影模糊程度
                        shadowOffsetX: 5,
                        shadowOffsetY: 5,
                        opacity: 1
                    },
                    emphasis: {
                        areaColor: "#082161",
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        shadowBlur: 5,
                        borderWidth: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)',
                        opacity: 1
                    }
                },
                // 添加投影配置
                // projection: {
                //     project: (point) => [point[0] / 180 * Math.PI, -Math.log(Math.tan((Math.PI / 2 + point[1] / 180 * Math.PI) / 2))],
                //     unproject: (point) => [point[0] * 180 / Math.PI, 2 * 180 / Math.PI * Math.atan(Math.exp(point[1])) - 90]
                // }
            },
            series: series
        };
        if(t){
            myChart.setOption(option.value, true);
            myChart.resize()
        }else{
            myChart.setOption(option.value);
        }     
        initialState.value = JSON.parse(JSON.stringify(option.value));
        myChart.on("georoam", function(params) {
            if (!params.zoom) return; // 不是缩放操作则返回
            let zoom = myChart.getOption().geo[0].zoom;
            initMap(zoom)
        });
    };
    let index = 1
    const initMap = (zoom,t) => {
        
        var options = myChart.getOption();
        zoomDq.value = options.geo[0].zoom; // 保持当前缩放级别
        
        // 定义临界缩放值
        // const ZOOM_THRESHOLD = 4.5;
        if (zoom > ZOOM_THRESHOLD.value && !georoamFlag) {
            georoamFlag = true;
            // 切换到详细地图（包含中国细节）
            useMap = { 
                ...worldMap, 
                features: worldMap.features.concat(chinaMap.features) 
            };
            echarts.registerMap('world', useMap);
            
            // 更新geo配置
            options.geo[0].map = "world";
            options.geo[0].zoom = zoom; // 保持当前缩放级别
            options.geo[0].label.show = true
            options.series[2].label.show = true
            myChart.setOption(options, true); // 强制重绘
            setTimeout(() => myChart.resize(), 50);
            
        } else if (zoom <= ZOOM_THRESHOLD.value && georoamFlag) {
            georoamFlag = false;
            // 切换回世界地图
            useMap = { ...worldMap };
            echarts.registerMap('world', useMap);
            
            // 更新geo配置
            options.geo[0].map = "world";
            options.geo[0].zoom = zoom;
            options.geo[0].label.show = false
            options.series[2].label.show = false
            myChart.setOption(options, true);
            setTimeout(() => myChart.resize(), 50);
        }else{
            if(t){
                options.geo[0].zoom = zoom;
                myChart.setOption(options, true);
                myChart.resize()
            }
            
        }
    }
    const zoomIn = () => {
        let zoom = myChart.getOption().geo[0].zoom;
        if (zoom < 10) {
            zoom += 0.2;
            initMap(zoom,true)
        }
    };
    const zoomOut = () => {
        let zoom = myChart.getOption().geo[0].zoom;
        if (zoom > 1) {
            zoom -= 0.2;
            initMap(zoom,true)
        }
    };
    const setMapCenter = (lng='119.168138', lat='36.713212') => {
        // let options = myChart.getOption();
        // options.geo[0].center = [119.168138, 36.713212];
        // myChart.setOption(options, true);
        // console.log(initialState.value,'数据')
        // myChart.setOption(initialState.value, true);
        // // myChart.dispatchAction({
        // //     type: 'restore', // 重置所有状态
        // // });
        getInfo(true)
    };
</script>

<style lang="less" scoped>
.chart {
    width: 100vw;
    height: 100vh;
}
.chartMap {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 400px; /* 关键设置 */
    .echartBox{
        position: relative;
        .iconButton{
            background: #fff;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            border-radius: 4px;
            margin-top: 5px;
        }
    }
}


</style>